const doctorateProgramsMap = {
  "Post Doc / D.Sc / D.Litt": {
    "D.Sc. (Doctor of Science)": [
      "Physics",
      "Mathematics",
      "Chemistry",
      "Engineering",
      "Environmental Science",
      "Data Science",
      "Artificial Intelligence",
    ],

    "D.Litt. (Doctor of Literature)": [
      "Literature",
      "History",
      "Political Science",
      "Sociology",
      "Law",
      "Education",
      "Philosophy",
    ],

    "Post-Doctoral Fellowship": [
      "Artificial Intelligence",
      "Robotics",
      "Finance",
      "Public Health",
      "Other major Ph.D. disciplines",
    ],
  },

  "Ph.D. Programs": {
    "Artificial Intelligence": [
      "Machine Learning",
      "Neural Networks",
      "Logic",
      "Intelligent Systems",
    ],

    "Data Science": [
      "Big Data",
      "Analytics",
      "Statistical Modeling",
      "Data Systems",
    ],

    Robotics: [
      "Automated Systems",
      "Control Theory",
      "Mechatronics",
      "Machine Intelligence",
    ],

    Cybernetics: ["Control Systems", "Robotics", "Systems Theory"],

    "Quantum Physics": [
      "Quantum Mechanics",
      "Field Theory",
      "Condensed Matter Physics",
    ],

    Chemistry: [
      "Physical Chemistry",
      "Organic Chemistry",
      "Inorganic Chemistry",
      "Biochemistry",
    ],

    Mathematics: ["Statistics", "Algebra", "Numerical Analysis"],

    "Political Science": [
      "Political Theory",
      "International Relations",
      "Comparative Politics",
    ],

    "Public Health": ["Epidemiology", "Health Policy", "Health Systems"],

    "Environmental Science": [
      "Ecological Systems",
      "Sustainability",
      "Environmental Policy",
    ],

    "Environmental Policy": [
      "Environmental Governance",
      "Regulation",
      "Policymaking",
    ],

    "Disaster Management": [
      "Risk Analysis",
      "Crisis Response",
      "Hazard Preparedness",
    ],

    Education: ["Pedagogy", "Curriculum Studies", "Educational Policy"],

    Law: ["Legal Theory", "Constitutional Law", "Comparative Legal Studies"],

    Economics: ["Microeconomics", "Macroeconomics", "Econometrics"],

    Finance: ["Financial Modeling", "Risk Analysis", "Corporate Finance"],

    "Risk Management": ["Financial Risk", "Operational Risk", "Strategic Risk"],
  },

  "Fellow Programme in Management (FPM)": {
    "FPM in Business Intelligence": [
      "Decision Sciences",
      "Data-driven Strategies",
      "AI / ML",
      "Strategic Intelligence",
    ],

    "FPM in Market Research": [
      "Consumer Behavior",
      "Survey Design",
      "Market Trends",
      "Quantitative Research",
      "Qualitative Research",
    ],

    "FPM in Marketing": [
      "Digital Marketing",
      "Branding",
      "Consumer Psychology",
      "Behavioral Modeling",
    ],

    "FPM in Finance": [
      "Asset Pricing",
      "Corporate Finance",
      "Econometrics",
      "Financial Modeling",
    ],

    "FPM in Analytics": [
      "Data Analytics",
      "Machine Learning",
      "Business Statistics",
      "Optimization Models",
    ],
  },

  "DM / M.Ch / DNB Medical Super-specialty Programs": {
    "DM in Oncology": ["Cancer Diagnosis", "Medical Oncology"],

    "M.Ch in Surgery": [
      "General Surgery",
      "Gastrointestinal Surgery",
      "Thoracic Surgery",
      "Other Surgical Specializations",
    ],

    "DM in Medicine": ["Management of Complex Systemic Illnesses"],

    "DNB in Radiology": [
      "Medical Imaging",
      "Diagnostics",
      "Interventional Radiology",
    ],

    "DM in Endocrinology": ["Diabetes", "Thyroid Disorders", "Metabolism"],

    "DNB or DM in Dermatology": [
      "Skin Disorders",
      "Hair Disorders",
      "Nail Disorders",
      "Related Systemic Conditions",
    ],
  },
};

export { doctorateProgramsMap };
